<div class="fx-row-w-100 fx-space-between fx-center">
  @if (selectedPos) {
    <span>Retrieve data for POS with domain prefix: {{selectedPos.domainPrefix}}</span>
  }

  @if (selectedPos == null) {
    <span>Select a POS below to retrieve data</span>
  }

  <div class="fx-row fx-center fx-h-center fx-gap-15">
    <mat-form-field appearance="outline" floatLabel="always" class="mr-10" style="width: 300px">
      <mat-label>Data types</mat-label>
      <mat-select [multiple]="true" [formControl]="selectedDataTypes" [matBadge]="selectedDataTypes ? selectedDataTypes!.value!.length : null">
        @for (type of dataTypes; track type) {
          <mat-option [value]="type.value">{{type.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button mat-mini-fab (click)="downloadVendData()" color="primary" class="mr-10" style="margin-bottom: 20px"
            [disabled]="!!(loading$ | async) || !selectedPos || !selectedDataTypes || selectedDataTypes!.value!.length == 0">
      <mat-icon matTooltip="Download (.zip)">download</mat-icon>
    </button>
  </div>

</div>
<app-crud-table title="Lease Point-of-Sale"
                subTitle="Download the lease point-of-sale payloads"
                [modelType]="leasePosModel"
                [loading$]="loading$"
                [tableData]="leasePosList"
                (rowSelected)="rowSelected($event)">
</app-crud-table>
